module.exports = __webpack_public_path__ + "static/img/img-about-6.4eff87c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-about-6.png
// module id = 16mM
// module chunks = 0